(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lucid-dreams-gallery"]) return;
  try {
    
(function () {
  var lb = document.getElementById('fl-lightbox');
  if (!lb) return;
  var lbImg = lb.querySelector('img');
  var lbCaption = lb.querySelector('.fl-lightbox-caption');

  function openLightbox(src, caption) {
    lbImg.src = src;
    lbImg.alt = caption;
    lbCaption.textContent = caption;
    lb.classList.add('is-open');
    lb.removeAttribute('hidden');
    document.body.classList.add('fl-no-scroll');
  }

  function closeLightbox() {
    lb.classList.remove('is-open');
    lb.setAttribute('hidden', '');
    document.body.classList.remove('fl-no-scroll');
  }

  document.querySelectorAll('.fl-item').forEach(function (btn) {
    btn.addEventListener('click', function () {
      openLightbox(this.dataset.src, this.dataset.caption);
    });
  });

  lb.querySelector('.fl-lightbox-close').addEventListener('click', closeLightbox);
  lb.addEventListener('click', function (e) { if (e.target === lb) closeLightbox(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLightbox(); });
})();

  } catch(e) { console.error(e); }
})();
})();
